export interface IWkMessageDialog {
  cancelLabel?: string;
  okLabel?: string;
  headerLabel?: string;
  message: string;
  okLabelClass?: string;
  cancelLabelClass?: string;
}
